/* unplugin-vue-components disabled */import { render } from "./ReportRepair.vue?vue&type=template&id=2849dec8&scoped=true"
import script from "./ReportRepair.vue?vue&type=script&lang=js"
export * from "./ReportRepair.vue?vue&type=script&lang=js"

import "./ReportRepair.vue?vue&type=style&index=0&id=2849dec8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2849dec8"]])

export default __exports__